<template>
  <div
    ref="demandApplyPage"
    class="container-fluid infinite-list"
    style="position: relative"
    infinite-scroll-disabled="disabled"
    infinite-scroll-immediate="false"
    v-infinite-scroll="getDemandList"
    @scroll="scroll"
  >
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <!-- 申請日期 -->
          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for="">申請日期</label>
              <el-date-picker
                class="w-100"
                type="daterange"
                :clearable="false"
                range-separator="~"
                start-placeholder="yyyy-MM-dd"
                end-placeholder="yyyy-MM-dd"
                v-model="applyDateRange"
              />
            </div>
          </div>

          <!-- 需求單單號 -->
          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for="">職缺單號</label>
              <el-input
                clearable
                maxlength="50"
                placeholder="請輸入關鍵字"
                v-model="searchCondition.manpowerDemandNo"
              />
            </div>
          </div>

          <!-- 需求單名稱 -->
          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for="">職缺名稱</label>
              <el-input
                clearable
                maxlength="50"
                placeholder="請輸入關鍵字"
                v-model="searchCondition.manpowerDemandName"
              />
            </div>
          </div>

          <!-- 職務名稱 -->
          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for="">{{ i18n("Position.PositionName") }}</label>
              <el-select
                class="w-100"
                filterable
                clearable
                v-model="searchCondition.positionCode"
                placeholder="請選擇"
              >
                <el-option
                  v-for="position in positionList"
                  :key="position.PositionCode"
                  :label="position.PositionName"
                  :value="position.PositionCode"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 需求單狀態 -->
          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for="">職缺狀態</label>
              <el-select
                class="w-100"
                clearable
                v-model="searchCondition.manpowerDemandStatus"
                placeholder="請選擇"
              >
                <el-option
                  v-for="status in statusOptions"
                  :key="status.Key"
                  :label="status.Value"
                  :value="status.Key"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 按鈕 -->
          <div class="col-sm-12 col-md-4">
            <button
              type="button"
              class="btn btn-primary btn-search"
              style="margin-top: 30px"
              @click="
                (pageNumber = 1),
                  (demandList = []),
                  (showDemandList = []),
                  (totalDemand = 0),
                  getDemandList()
              "
            >
              {{ i18n("Buttons.Search") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-search"
              style="margin-top: 30px; margin-left: 10px"
              @click="createDemand"
            >
              {{ i18n("Buttons.Add") }}
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              style="margin-top: 30px; margin-left: 10px"
              @click="
                searchCondition = {};
                applyDateRange = [
                  new Date($common.getThreeMonthsAgo()),
                  new Date($common.getToday()),
                ];
              "
            >
              清除
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="demandList.length > 0">
      <div class="tool-list-about-card">
        <span
          @click="gridStyle = 'block'"
          :class="{ active: gridStyle == 'block' }"
        >
          <eva-icon fill="#000" name="grid-outline" />
        </span>
        <span
          @click="gridStyle = 'list'"
          :class="{ active: gridStyle == 'list' }"
        >
          <eva-icon fill="#000" name="list-outline" />
        </span>
      </div>
    </div>

    <!-- 卡片列表 -->
    <div
      class="demand-card-list"
      :class="{
        'list-style': gridStyle === 'list',
        'block-style': gridStyle === 'block',
      }"
    >
      <div
        v-for="(demand, index) in demandList"
        :key="demand.Guid + index"
        class="demand-card infinite-list-item"
      >
        <DemandCard
          ref="demandCard"
          :category="'apply'"
          :data="demand"
          :showCheckbox="true"
          @updateSelectDemand="updateSelectDemand"
        >
          <template v-slot:apply="{ props }">
            <button
              v-if="props.ManpowerDemandStatus === 'New'"
              type="button"
              class="btn"
              @click="editDemand(props.Guid)"
            >
              編輯
            </button>
          </template>
        </DemandCard>
      </div>
    </div>

    <!-- 功能列 -->
    <ActionBar
      :show="showActionBar"
      :cardType="'demandCard'"
      :cardStatus="cardStatus"
      :selectedCardList="chooseDemandList"
      @showActionBar="showActionBar = !showActionBar"
      @selectAllCards="selectAllCards"
      @clearSelectCard="clearSelectCard"
    >
      <template v-slot:button="{ props }">
        <button
          v-if="props === null || props === 'New'"
          type="button"
          class="action-btn"
          @click="batchApproval()"
        >
          <eva-icon name="person-outline" fill="#FFF" />
          <span>送出</span>
        </button>

        <button
          v-if="props === null || props === 'New' || props === 'Pending'"
          type="button"
          class="action-btn"
          style="background-color: red"
          @click="openActionModal()"
        >
          <eva-icon name="trash-outline" fill="#FFF" />
          <span>作廢</span>
        </button>
      </template>
    </ActionBar>

    <!-- 檢視需求單 -->
    <DemandDetailModal />

    <!-- API 回應訊息 -->
    <ResponseDataModal
      :successfulList="successMessage"
      :failedList="failMessage"
    />

    <!--作廢 Modal-->
    <div
      id="deleteModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <ValidationObserver
            ref="deleteValid"
            class="modal-content"
            v-slot="{ handleSubmit, reset }"
          >
            <form
              @submit.prevent="handleSubmit(deleteDemand)"
              @reset.prevent="reset"
            >
              <div class="modal-header">
                <span>作廢</span>
              </div>
              <div class="modal-body">
                <div class="form-group">確認作廢 ?</div>
                <div class="form-group">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <textarea
                      cols="50"
                      rows="5"
                      maxlength="200"
                      class="form-control"
                      placeholder="請輸入原因(必填)"
                      @compositionstart="is_composing = true"
                      @compositionend="is_composing = false"
                      v-model="deleteReason"
                    />
                    <span v-if="errors[0] && !is_composing" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  {{ i18n("Buttons.Cancel") }}
                </button>
                <button type="submit" class="btn btn-danger">作廢</button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
// 需求單卡片
import DemandCard from "@/components/back/Card/Demand";
// 功能列
import ActionBar from "@/components/back/ToolBar/ActionBar";
import DemandDetailModal from "@/components/back/Modal/DemandDetail";
import ResponseDataModal from "@/components/back/Modal/ResponseData";

export default {
  name: "DemandApply",

  components: {
    DemandCard,
    ActionBar,
    DemandDetailModal,
    ResponseDataModal,
  },
  data() {
    return {
      // 需求單列表顯示樣式(區塊/條列)
      gridStyle: "block",

      is_composing: false,

      // 需求單狀態
      statusOptions: [
        { Key: null, Value: "全部" },
        { Key: "New", Value: "新建" },
        { Key: "Approved", Value: "同意" },
        { Key: "Suspend", Value: "停用" },
        { Key: "Cancelled", Value: "作廢" },
      ],

      // 查詢
      applyDateRange: [], // 申請日起訖
      positionList: [], // 職務列表
      supervisorOptions: [], // 主管列表
      searchCondition: {}, // 欄位data
      cardStatus: null, // 卡片狀態

      // 審核人員資料
      supervisorData: null,

      // 作廢原因
      deleteReason: null,

      // API 回應資訊
      successMessage: [], // 成功訊息
      failMessage: [], // 失敗訊息

      // 功能列
      showActionBar: false, // 預設不顯示

      // 選取之需求單列表
      chooseDemandList: [],

      // page data
      pageTarget: "", // 當前網頁的 target
      currentPercent: 0, // 當前網頁百分比
      scrollOnPageTop: false, // 卷軸是否在當前網頁的 20%
      // 停止call API（停止取得下一頁）
      stopGetNextPage: false,

      // 需求單資料
      pageNumber: 1, // 當前頁數
      totalDemand: 0, // 實際取得的人員總數
      demandList: [], // 實際取得的人員列表
      showDemandList: [], // 顯示於畫面的人員列表
    };
  },

  methods: {
    // 卷軸
    scroll(e) {
      this.pageTarget = e.target;
      this.currentPercent =
        ((this.pageTarget.scrollTop + this.pageTarget.clientHeight) /
          this.pageTarget.scrollHeight) *
        100;
    },

    // 取得需求申請列表
    getDemandList() {
      const vm = this;
      const api = `${window.endpoints.api}/ManpowerDemandModule/WithStatistics`;

      const params = {
        ...vm.searchCondition,
        startDate:
          vm.applyDateRange[0] === null
            ? null
            : this.dayjs(vm.applyDateRange[0]).format("YYYY-MM-DD"),
        endDate:
          vm.applyDateRange[1] === null
            ? null
            : this.dayjs(vm.applyDateRange[1]).format("YYYY-MM-DD"),
        page: vm.pageNumber,
        perPage: 40,
      };

      vm.cardStatus = params.manpowerDemandStatus;

      vm.clearSelectCard();
      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            vm.totalDemand = response.data.DataQuantity;
            let newArr = response.data.Datas.map((item) => {
              return {
                ...item,
                isChecked: false,
              };
            });

            let oldArr;
            if (vm.pageNumber === 1) {
              oldArr = [];
            } else {
              oldArr = vm.demandList;
            }
            vm.pageNumber += 1;
            vm.demandList = oldArr.concat(newArr);

            vm.showDemand();

            vm.$store.dispatch("updateLoading", false);
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "查詢失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 顯示於畫面的列表
    showDemand() {
      const vm = this;
      if (vm.demandList.length <= 40) {
        vm.showDemandList = [...vm.demandList];
      }

      if (vm.currentPercent >= 90) {
        let lastDemand = vm.showDemandList[vm.showDemandList.length - 1]; // 取得目前畫面上的最後一筆人員
        let lastDemandIndex = vm.demandList.indexOf(lastDemand); // 找出此人員在實際列表中的索引值
        let rows = vm.demandList.slice(
          lastDemandIndex + 1,
          lastDemandIndex + 21
        );
        vm.showDemandList = vm.showDemandList.concat(rows); // 加入後20筆人員
        vm.showDemandList.splice(0, 20); // 刪除前20筆，保持40筆顯示

        vm.$refs.demandApplyPage.scroll({
          top: vm.pageTarget.scrollHeight / 2 - vm.pageTarget.clientHeight,
          behavior: "auto",
        });

        this.scrollOnPageTop = false;
      }
    },

    // 即時更新選取需求單之列表
    updateSelectDemand(chooseDemand) {
      let repeatIndex = this.chooseDemandList.findIndex(
        (element) => element.Guid === chooseDemand.Guid
      );
      repeatIndex === -1
        ? this.chooseDemandList.push(chooseDemand)
        : this.chooseDemandList.splice(repeatIndex, 1);
    },

    // Action Modal
    openActionModal() {
      this.deleteReason = null;
      this.$refs.deleteValid.reset();
      $("#deleteModal").modal("show");
    },

    // 需求單 批次送出且直接結案
    batchApproval() {
      const result = this.chooseDemandList.filter(
        (item) => item.ManpowerDemandStatus === "New"
      );
      if (result.length === 0) {
        this.$notify({
          title: "失敗",
          message: "請選取未送出之需求單",
          type: "error",
          duration: 3000,
        });
      } else {
        this.updateLoading(true);
        this.$api.manpowerDemand
          .postSendToApproved({
            ManpowerDemandGuids: result.map((item) => item.Guid),
          })
          .then((response) => {
            if (response.status === 200) {
              this.successMessage = response.data.filter((item) => {
                return item.indexOf("成功") !== -1;
              });
              this.failMessage = response.data.filter((item) => {
                return item.indexOf("失敗") !== -1;
              });
              this.$store.commit("OpenResponseDataModal", true);
            }
            this.clearSelectCard();
            this.updateLoading(false);
            this.pageNumber = 1;
            this.totalDemand = 0;
            this.demandList = [];
            this.getDemandList();
          });
      }
    },

    // 作廢需求單 API
    deleteDemand() {
      const vm = this;
      const api = `${window.endpoints.api}/ManpowerDemandModule/Cancelled`;

      const data = {
        Sender: vm.$cookies.get("userName"),
        CancelledReason: vm.deleteReason,
        ManpowerDemandGuid: vm.chooseDemandList.map((item) => item.Guid),
      };
      $("#deleteModal").modal("hide");

      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);

            vm.successMessage = response.data.filter((item) => {
              return item.indexOf("成功") !== -1;
            });
            vm.failMessage = response.data.filter((item) => {
              return item.indexOf("失敗") !== -1;
            });
            vm.$store.commit("OpenResponseDataModal", true);

            if (vm.cardStatus === null) {
              data.ManpowerDemandGuid.map((item) => {
                vm.demandList.forEach((ele, index, arr) => {
                  if (ele.Guid === item) {
                    arr[index].ManpowerDemandStatus = "Cancelled";
                  }
                });
              });
            } else {
              data.ManpowerDemandGuid.map((item) => {
                vm.demandList.forEach((ele, index, arr) => {
                  if (ele.Guid === item) {
                    arr.splice(index, 1);
                  }
                });
              });
            }

            vm.clearSelectCard();
          }
        })
        .catch((error) => {
          vm.clearSelectCard();
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "作廢失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 全選
    selectAllCards() {
      this.demandList.forEach((item) => {
        if (!item.isChecked) {
          item.isChecked = true;
        }
      });
      this.chooseDemandList = this.demandList.filter(
        (item) => item.isChecked === true
      );
    },

    // 清除
    clearSelectCard() {
      this.demandList.forEach((item) => {
        item.isChecked = false;
      });
      this.chooseDemandList = [];
    },

    // 新增需求單
    createDemand() {
      this.$router.push({ name: "招募管理,需求單" });
    },

    // 編輯需求單
    editDemand(demandGuid) {
      localStorage.setItem("demandGuid", demandGuid);
      this.$router.push({ name: "招募管理,編輯需求單" });
    },

    async getData() {
      const backgroundUser = await this.$api.backgroundUser.getBackgroundUser();

      // 取得主管列表
      this.supervisorOptions = backgroundUser.data.map((user) => {
        return {
          Guid: user.UserId,
          Name: user.Name,
          Email: user.Email,
        };
      });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    disabled() {
      return this.stopGetNextPage;
    },

    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    chooseDemandList: function (e) {
      this.showActionBar = e.length > 0;
    },

    currentPercent(e) {
      if (this.demandList.length > 40) {
        // 向上滑動，觸發「前20筆」
        if (e < 20 && !this.scrollOnPageTop) {
          this.scrollOnPageTop = true;
          let firstDemand = this.showDemandList[0]; // 取得目前畫面上的第一筆人員

          if (
            JSON.stringify(firstDemand) !== JSON.stringify(this.demandList[0])
          ) {
            // 找出此人員在實際列表中的索引值
            const firstDemandIndex = this.demandList.indexOf(firstDemand);
            // 以此索引值在實際列表中的位置做為依據，取得前 20 筆人員
            let rows = this.demandList.slice(
              firstDemandIndex - 20,
              firstDemandIndex
            );
            rows = rows.concat(this.showDemandList); // 加入取得的 21 筆人員
            this.showDemandList = [...rows];
            this.showDemandList.splice(40, 20); // 刪除列表中原有的後 21筆人員，保持列表大小(36筆)

            this.$refs.demandApplyPage.scroll({
              top:
                this.pageTarget.scrollHeight / 2 - this.pageTarget.clientHeight,
              behavior: "auto",
            });

            this.scrollOnPageTop = false;
          }
        }

        // 向下滑動，觸發「載入後20筆」
        if (e >= 90 && this.demandList.length === this.totalDemand) {
          const lastDemand =
            this.showDemandList[this.showDemandList.length - 1]; // 取得目前畫面上的最後一筆人員
          const isLastItem =
            JSON.stringify(lastDemand) ===
            JSON.stringify(this.demandList[this.demandList.length - 1]);

          this.stopGetNextPage = isLastItem;
          if (!isLastItem) {
            this.showDemand();
          }
        }
      } else if (e >= 90 && this.demandList.length === this.totalDemand) {
        // 只有 40 筆以下資料時的向下滑動邏輯
        this.stopGetNextPage = true;
      }
    },
  },

  created() {
    this.getData();

    this.applyDateRange = [
      new Date(this.$common.getThreeMonthsAgo()),
      new Date(this.$common.getToday()),
    ];

    this.$set(
      this.searchCondition,
      "applicantGuid",
      this.$cookies.get("userId")
    );
    this.$set(this.searchCondition, "manpowerDemandStatus", null);

    this.getDemandList();

    // 取得職務列表
    this.get_position(null)
      .then((result) => {
        this.positionList = result;
      })
      .catch((error) =>
        this.$notify({
          title: "職務列表取得失敗",
          message: error.response.data,
          type: "error",
          duration: 3500,
        })
      );
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
